export default {
  name: 'UserPickerExtended',
  props: {
    value: {
      type: Object,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    roles: {
      type: Array | Object,
      default: () => null
    },
    qry: {
      type: String,
      default: null
    },
    companies: {
      type: Array | Object,
      default: () => null
    },
    getItemText: {
      type: Function,
      default: (item) => (item ? item.fullname + ' (' + item.email + ')' : '')
    },
    controlClass: {
      type: String,
      default: ''
    },
    isInvalid: {
      type: Boolean,
      default: false
    },
    filters: {
      type: Object,
      default: () => null
    },
    dbparam: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      loading: false,
      content: this.value,
      itemOptions: null,
      searchTxt: '',
      currentReq: null,
      roleIsNotValid: false,
      usersNotFound: false,
      isSearching: false
    };
  },
  computed: {
    hasAnyResults () {
      return this.itemOptions && this.searchTxt && this.searchTxt.length > 0 && this.itemOptions.length === 0;
    }
  },
  methods: {
    updateValue () {
      this.$emit('input', this.content);
      this.$emit('changed', this.content);
    },
    searchFocus () {
      if (this.content === null) {
        this.searchItem(this.searchTxt)
      }
    },
    searchItem () {
      console.log('searchItem');
      this.isSearching = true;
      if (this.currentReq) {
        this.currentReq.cancel('changed search query');
      }
      if (this.content) {
        this.content = null;
        this.updateValue();
      }
      const self = this;
      const search = this.searchTxt.trim();
      if (search.length > 0 || self.roles) {
        setTimeout(
          function () {
            if (search === self.searchTxt.trim()) {
              self.loading = true;
              let path = 'user/find?perPage=10&qry=' + search;
              if (self.roles) {
                path += '&roles=' + self.roles;
              }
              if (self.companies) {
                path += '&companies=' + self.companies;
              }
              path = self.ApiRequest.addGetParamsToPath(path, self.filters, true)
              if (self.qry) {
                path += self.qry;
              }
              self.currentReq = self.ApiRequest.request(path, self.ApiRequest.REQUEST_GET, [], function (response) {
                if (response.data) {
                  self.itemOptions = response.data;
                  self.loading = false;
                  if (response.data.length < 1) {
                    self.content = { fullname: self.searchTxt };
                    self.updateValue();
                    self.usersNotFound = true;
                  } else {
                    self.usersNotFound = false;
                  }
                }
                self.isSearching = false;
              });
            }
          }, 500);
      } else {
        this.loading = false;
        self.isSearching = false;
        self.itemOptions = null;
      }
    },
    selectItem (item) {
      this.searchTxt = this.getItemText(item);
      this.content = item;
      this.updateValue();
      this.itemOptions = null;
      this.loading = false;
    },
    clearSearch () {
      this.itemOptions = null;
      this.searchTxt = '';
      this.content = null;
      this.loading = false;
      this.updateValue();
    },
    editElement (refName, element) {
      this.$refs[refName].show(element);
    }
  },
  mounted () {
    this.searchTxt = this.getItemText(this.content);
  },
  watch: {
    value: {
      immediate: true,
      handler (val) {
        this.roleIsNotValid = false;
        if (this.roles != null && val != null && typeof this.roles == 'object' && Object.values(this.roles).length > 0) {
          if (val.roles == null || (val.roles != undefined && val.roles.length == 0)) {
            this.roleIsNotValid = true;
          } else {
            if (val.roles != undefined && val.roles != null && val.roles.length > 0) {
              let failedCheck = true;
              const validRoleValues = Object.values(this.roles)
              val.roles.forEach(el => {
                if (failedCheck == true) {
                  if (typeof el == 'object' && el.name != undefined) {
                    if (validRoleValues.includes(el.name)) {
                      failedCheck = false;
                    }
                  } else {
                    failedCheck = false;
                  }
                }
              })
              if (failedCheck) {
                this.roleIsNotValid = true;
              }
            }
          }
        }
        if (val != null && val.isDisabled != undefined && val.isDisabled) {
          this.roleIsNotValid = true;
        }
        if (val != this.content) {
          this.content = val;
          this.searchTxt = this.getItemText(this.content);
        }
      }
    }
  }
}
